import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "m15.231 19.931-2.951 2.952a.394.394 0 0 1-.558 0L8.771 19.93a.394.394 0 0 1 .278-.673h2.163V12.79h-6.47v2.162a.394.394 0 0 1-.673.28L1.117 12.28a.394.394 0 0 1 0-.558L4.07 8.77a.394.394 0 0 1 .673.279v2.162h6.47v-6.47H9.05a.394.394 0 0 1-.278-.673l2.951-2.951a.394.394 0 0 1 .558 0l2.951 2.951a.394.394 0 0 1-.279.673H12.79v6.47h6.47V9.05c0-.352.424-.528.673-.28l2.951 2.952a.394.394 0 0 1 0 .558l-2.951 2.951a.394.394 0 0 1-.673-.279V12.79h-6.47v6.468h2.163c.351 0 .527.425.279.673Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function c(r, d) {
  return e(), t("svg", a, [...n]);
}
const s = { render: c };
export {
  s as default,
  c as render
};
